import { render, staticRenderFns } from "./BtnAtualizarRateioRequisicao.vue?vue&type=template&id=1e2b4d76"
import script from "./BtnAtualizarRateioRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarRateioRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports